import { render, staticRenderFns } from "./MetaMask.vue?vue&type=template&id=4de71de1&"
import script from "./MetaMask.vue?vue&type=script&setup=true&lang=js&"
export * from "./MetaMask.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports